// extracted by mini-css-extract-plugin
export var capsule = "capsule-module--capsule--da280";
export var title = "capsule-module--title--bda47";